/* eslint-disable sort-keys-fix/sort-keys-fix */
import { Params } from '@angular/router';

export const ACCESS_ROUTE = {
  DEFAULT: '',
  INVALID_INPUT: {
    name: 'invalid-input',
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name];
    }
  },
  KH_SAML_INTERNAL: {
    name: 'kh-saml-internal',
    queryParams(redirectUrl: string, targetUrl: string): Params {
      return {
        redirectUrl: redirectUrl,
        targetUrl: targetUrl
      }
    },
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name]
    }
  },
  KH_SAML_INTERNAL_LOGOUT: {
    name: 'kh-saml-internal-logout',
    queryParams(redirectUrl: string, targetUrl: string): Params {
      return {
        redirectUrl: redirectUrl,
        targetUrl: targetUrl
      }
    },
    route(): string[] {
      return ['/' + this.name]
    }
  },
  KH_SAML_LOGOUT_REDIRECT: {
    name: 'kh-saml-logout-redirect',
    route(): string[] {
      return ['/' + this.name]
    }
  },
  KH_SAML_REDIRECT: {
    name: 'kh-saml-redirect',
    queryParams(token: string, targetUrl: string, authInfo: string, coreUrl: string): Params {
      return {
        authInfo: authInfo,
        targetUrl: targetUrl,
        token: token,
        coreUrl: coreUrl
      }
    },
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name]
    }
  },
  LINK_SENT: {
    name: 'link-sent',
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name];
    }
  },

  CREATE_YOUR_PASSWORD_MESSAGE: {
    name: 'create-your-password-message',
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name];
    }
  },
  name: 'login',
  route(): string[] {
    return [`/${ACCESS_ROUTE.name}`];

  },
  UPDATE_YOUR_PASSWORD: {
    name: 'update-your-password',
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name];
    }
  },
  LOGIN_ISSUE_MESSAGE: {
    name: 'login-issue',
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name];
    }
  },
  VALIDATE_EMAIL: {
    name: 'verify-email',
    queryParams(email: string): Params {
      return {
        email: email
      };
    },
    route(): string[] {
      return [...ACCESS_ROUTE.route(), this.name]
    }
  }
};
